import { makeGraphqlRequestCloud } from 'api/graphql/graphQLClient';
import { CreateReport } from '@/graphql/cloud/reports/mutations/CreateReport.graphql';
import { ReportByInjectionId } from '@/graphql/cloud/reports/subscriptions/ReportByInjectionId.graphql';
import { subscribe } from 'api/graphql/wsHasuraClient';

export const apiReports = {
  async createReport(
    template,
    params,
    token,
    sequenceId,
    injectionId,
    sharedToken,
    sharedObjectId,
  ) {
    const { report } = await makeGraphqlRequestCloud(
      CreateReport,
      {
        template,
        params,
        token,
        sequence_id: sequenceId,
        injection_id: injectionId,
      },
      1,
      sharedToken,
      sharedObjectId,
    );

    if (!report) {
      throw new Error('Report creation failed!');
    }

    return report;
  },
  subscribeForReportByInjectionId(injectionId, onReportUpdate, sharedToken, sharedObjectId) {
    return subscribe(
      ReportByInjectionId,
      { injectionId },
      ({ report }) => {
        onReportUpdate(report);
      },
      sharedToken,
      sharedObjectId,
    );
  },
};
